import { Link } from '../common';

export interface Opportunity {
  opportunityId: number;
  links: Link;
  self: string;
}
